import { useEffect, useRef } from 'react'
import { useSelector } from 'react-redux'
import { useNavigate } from 'react-router-dom'

import { BackHeader } from '@/components/BackHeader/BackHeader'
import { PlansGrid } from '@/components/Payment/PlansGrid'
import { WeScreen } from '@/components/WeScreen/WeScreen'
import { AppRoutes } from '@/constants/appRoutes'
import { useStripe } from '@/hooks/Stripe/useStripe'
import { selectHasToken } from '@/store/api/Auth/Auth.selector'
import { useUserInfoQuery } from '@/store/api/Users/Users.query'
import { trackPricingTableViewed } from '@/utils/analytics'

export const ImpersonationPaywall = () => {
  const hasTrackedPricingTableViewed = useRef(false)
  const hasToken = useSelector(selectHasToken)

  const { data: userData, isLoading: isLoadingUserData } = useUserInfoQuery(
    undefined,
    {
      skip: !hasToken,
    },
  )
  const {
    pricingProducts,
    isLoadingPricing,
    isPricingSuccess,
    handleSelectPlan,
  } = useStripe({
    skipTopup: true,
    productType: 'impersonation',
    successRoute: AppRoutes.impersonationPaymentSuccess,
  })

  const navigate = useNavigate()

  useEffect(() => {
    if (!hasTrackedPricingTableViewed.current) {
      trackPricingTableViewed()
      hasTrackedPricingTableViewed.current = true
    }
  }, [])

  const stripeCustomerId = userData?.stripeCustomerId
  const userEmail = userData?.email

  return (
    <WeScreen
      isLoading={isLoadingUserData || isLoadingPricing}
      useHeader={false}
      customViewStyles="max-md:p-0"
    >
      {isPricingSuccess && (
        <div className="flex flex-col items-center w-full h-full min-h-full overflow-y-auto custom-scrollbar relative">
          <div className="flex flex-start w-full px-4 lg:px-10">
            <BackHeader
              onPressBack={() => navigate(AppRoutes.impersonationScreening)}
            />
          </div>

          <div className="w-full flex flex-col items-center justify-start py-6 lg:py-10">
            <div className="w-full max-w-5xl px-4 lg:px-0">
              <PlansGrid
                plans={pricingProducts}
                isLoading={isLoadingPricing}
                onSelectPlan={(product) =>
                  handleSelectPlan(product, {
                    customerId: stripeCustomerId,
                    email: userEmail,
                  })
                }
              />
            </div>
          </div>
        </div>
      )}
    </WeScreen>
  )
}
